export enum SourcedJobsCampaignMode {
  LEADS = 'leads',
  AUTOPILOT = 'autopilot',
}
